import { ServiceMode } from 'state/service-mode/types';

import { IsServiceModeValid } from './types';

export const isServiceModeValid: IsServiceModeValid = ({ serviceMode }) =>
  serviceMode !== ServiceMode.DELIVERY;
